import React, { useEffect, useState } from "react";
import Select from "react-select";
import CircularProgress from "@mui/material/CircularProgress";

export default function MultiSelect({
  options = [],
  value,
  onChange,
  onScrollBottom,
  onInputChange,
  isLoading = false,
  placeholder = "Select options",
  width = "100%",
  isMulti,
  hasMore,
  onFocus,
  isDisabled,
  onBlur,
  closeMenuOnSelect
}) {
  const optionsWithStatus = (() => {
    if (isLoading) {
      return [
        ...options,
        {
          value: "__loading__",
          label: (
            <div style={{ textAlign: "center", padding: 8 }}>
              <CircularProgress size={18} />
            </div>
          ),
          isDisabled: true,
        },
      ];
    }

    if (!hasMore && options.length > 0) {
      return [
        ...options,
        {
          value: "__no_more__",
          label: (
            <div
              style={{
                textAlign: "center",
                padding: 8,
                color: "#c50000",
                fontSize: 12,
              }}
            >
              No more data
            </div>
          ),
          isDisabled: true,
        },
      ];
    }

    return options;
  })();

  return (
    <div style={{ width }}>
      <Select
        isMulti={isMulti || false}
        isClearable={false}
        options={optionsWithStatus}
        value={value}
        closeMenuOnSelect={closeMenuOnSelect || false}
        onKeyDown={(e) => {
    if (e.key === "Enter" || e.key === " ") {
    e.preventDefault();
    e.stopPropagation();
  }
  }}
        tabSelectsValue={false}
        enterSlected={false}
        onChange={onChange}
        onBlur={onBlur}
        onMenuScrollToBottom={onScrollBottom}
        onInputChange={onInputChange}
        onFocus={onFocus}
        placeholder={placeholder}
        // isOptionDisabled={(opt) => opt.isDisabled}
        isDisabled={isDisabled}
        classNamePrefix="react-select"
        noOptionsMessage={() => "No more data"}
      />
    </div>
  );
}
